import { SelectMenuComponents } from 'bold-ui/lib/components/Select/SelectSingle/SelectDownshiftMenu'
import { CustomSelectFieldProps } from 'components/form'
import { SelectFieldWithAddButton } from 'components/form/final-form/SelectField/SelectFieldWithAddButton'
import { CIDADAO_PATH } from 'components/layout/SideMenu/SideMenuItems'
import { useHistory } from 'react-router-dom'

import { CidadaoSelectFieldItem } from '../CidadaoSelectField'
import { AsyncQuerySelectProps } from '../useAsyncQuerySelect'
import { CidadaoAtendimentoSelectFieldModel } from './CidadaoAtendimentoSelectField'

type CidadaoAtendimentoSelectFieldCommonProps = CustomSelectFieldProps<CidadaoAtendimentoSelectFieldModel> & {
  addCidadaoCallbackUrl: string
  placeholder: string
  components: Partial<SelectMenuComponents<CidadaoAtendimentoSelectFieldModel>>
  selectProps: AsyncQuerySelectProps<CidadaoAtendimentoSelectFieldModel>
  verificarPresenteNaListaAtendimento?: boolean
  onBeforeRedirect?: () => void
}

export function CidadaoAtendimentoSelectFieldCommon(props: CidadaoAtendimentoSelectFieldCommonProps) {
  const {
    addCidadaoCallbackUrl,
    placeholder,
    components,
    selectProps,
    verificarPresenteNaListaAtendimento = true,
    onBeforeRedirect,
    ...rest
  } = props

  const history = useHistory()

  const handleClickCadastrarButton = () => {
    onBeforeRedirect?.()
    setTimeout(() => history.push(`${CIDADAO_PATH}?callbackUrl=${addCidadaoCallbackUrl}`))
  }

  return (
    <SelectFieldWithAddButton<CidadaoAtendimentoSelectFieldModel>
      itemToString={itemToString}
      renderItem={renderItem}
      itemIsEqual={verificarPresenteNaListaAtendimento && isPresente}
      menuMinWidth={500}
      popperProps={popperProps}
      addText='Cadastre somente se não o encontrar na busca.'
      addButtonText='Adicionar cadastro'
      onClickAddButton={handleClickCadastrarButton}
      placeholder={placeholder}
      components={components}
      {...selectProps}
      {...rest}
    />
  )
}

const isPresente = (cidadao: CidadaoAtendimentoSelectFieldModel) => cidadao.presenteListaAtendimento

const itemToString = (item: CidadaoAtendimentoSelectFieldModel) => item?.nomeSocial || item?.nome

const renderItem = (item: CidadaoAtendimentoSelectFieldModel) => {
  return item && <CidadaoSelectFieldItem item={item} />
}

const popperProps = { modifiers: [{ name: 'preventOverflow', enabled: false }] }
